module.exports = __webpack_public_path__ + "img/L1_Frame_Door.4699f7f3.svg";